import classnames from 'classnames';
import getIn from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import DropdownCaretForWhiteIcon from '../../../static/icons/ic_chevron_down_16.svg';
import DropdownCaretIcon from '../../../static/icons/ic_dropdown_custom.svg';
import * as Actions from '../../actions';
import Icon from '../../components/Icon/Icon';
import * as Constants from '../../constants';
import { isDropdownTypeOpen } from '../../tools/Dropdowns/DropdownUtils';
import { ShuffleToggleDropdownKey } from '../../tools/Dropdowns/ShuffleToggleDropdown';

import './ShuffleDropdownCaret.scss';

const STYLES = Constants.Shuffle.buttonStyles;

class ShuffleDropdownCaret extends React.Component {
  static propTypes = {
    openDropdown: PropTypes.func.isRequired,
    closeDropdown: PropTypes.func,
    isDropdownOpen: PropTypes.bool,
    extraClass: PropTypes.string,
    style: PropTypes.oneOf([STYLES.DEFAULT, STYLES.COMPACT, STYLES.COMPACT_MIN, STYLES.WHITE]),
  };

  state = {
    isActive: false,
  };

  componentWillUpdate(nextProps) {
    if (!nextProps.isDropdownOpen && this.state.isActive) {
      // FIXME
      // eslint-disable-next-line react/no-will-update-set-state
      this.setState({
        isActive: !this.state.isActive,
      });
    }
  }

  openOrCloseDropdown = config => {
    if (this.state.isActive) {
      this.props.openDropdown({
        menuType: ShuffleToggleDropdownKey,
        config,
      });
    } else {
      this.props.closeDropdown();
    }
  };

  handleClick = e => {
    e.stopPropagation();
    const rect = getIn(e, ['target', 'parentElement', 'getBoundingClientRect'])
      ? e.target.parentElement.getBoundingClientRect()
      : null;
    const config = {
      position: rect,
      alignVertical: Constants.Dropdown.DropdownConstants.ALIGN_TOP,
      alignHorizontal: Constants.Dropdown.DropdownConstants.ALIGN_RIGHT,
      positionAdjustments: {
        vertical: rect.height + 4,
        horizontal: -14,
      },
    };
    this.setState(
      {
        isActive: !this.state.isActive,
      },
      () => {
        this.openOrCloseDropdown(config);
      },
    );
  };

  render() {
    const glyph = this.props.style === STYLES.WHITE ? DropdownCaretForWhiteIcon : DropdownCaretIcon;
    const iconClass = classnames('icon-drop-caret', {
      'icon-drop-caret--active': this.state.isActive,
    });
    const componentClass = classnames('ShuffleDropdownCaret', {
      [this.props.extraClass]: !!this.props.extraClass,
      [`ShuffleDropdownCaret--${this.props.style}`]: !!this.props.style,
    });
    const iconAttributes = {
      [Constants.Accessibility.AriaAttributes.HIDDEN]: true,
    };
    const componentAriaAttributes = {
      [Constants.Accessibility.AriaAttributes.LABEL]: 'Shuffle Options',
    };
    return (
      <button
        type='button'
        className={componentClass}
        onClick={this.handleClick}
        {...componentAriaAttributes}
      >
        <Icon className={iconClass} aria={iconAttributes} key='icon-drop-caret' glyph={glyph} />
      </button>
    );
  }
}

export function mapStateToProps(state) {
  const isDropdownOpen = isDropdownTypeOpen(state, ShuffleToggleDropdownKey);
  return {
    isDropdownOpen,
  };
}

export default connect(mapStateToProps, {
  openDropdown: Actions.Dropdown.openDropdown,
  closeDropdown: Actions.Dropdown.closeDropdown,
})(ShuffleDropdownCaret);
